import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanelTop from './rightPanelTop';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function EditPortalSettingsModal(props) {
  const showEditPortalSetting = useSelector((state) => state.modalReducer.showEditPortalSetting);
  const selectedPortalSettingValue = useSelector((state) => state.portalSettingReducer.selectedPortalSettingValue);
  const [resetButtonTriggerValueChange, setResetButtonTriggerValueChange] = useState(false);
  const [latestValueSaveChange, setLatestValueSaveChange] = useState(selectedPortalSettingValue?.currentValue);

  useEffect(() => {
    if (!resetButtonTriggerValueChange) {
      setLatestValueSaveChange(selectedPortalSettingValue?.currentValue);
    } else {
      setLatestValueSaveChange(selectedPortalSettingValue?.defaultValue);
    }
  }, [selectedPortalSettingValue, resetButtonTriggerValueChange]);

  let editPortalSettingModal = showEditPortalSetting ? (
    <Modal show={showEditPortalSetting} hideWhenClickAway={false} className="ui modal suspend-waiting-area">
      <PopupHeader
        title={APP.LANGUAGE.AdminMenu.ManagePortalSettings}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpSuspendOrResume}
      />
      <div className="content">
        <div className="main-ui-container meeting-room-create-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanelTop
                  latestValueSaveChange={latestValueSaveChange}
                  setLatestValueSaveChange={setLatestValueSaveChange}
                  resetButtonTriggerValueChange={resetButtonTriggerValueChange}
                  setResetButtonTriggerValueChange={setResetButtonTriggerValueChange}
                />
              </div>
            </div>
            <CenterPanel
              latestValueSaveChange={latestValueSaveChange}
              setLatestValueSaveChange={setLatestValueSaveChange}
              resetButtonTriggerValueChange={resetButtonTriggerValueChange}
              setResetButtonTriggerValueChange={setResetButtonTriggerValueChange}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanelTop
                latestValueSaveChange={latestValueSaveChange}
                setLatestValueSaveChange={setLatestValueSaveChange}
                resetButtonTriggerValueChange={resetButtonTriggerValueChange}
                setResetButtonTriggerValueChange={setResetButtonTriggerValueChange}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    ''
  );

  return <div>{editPortalSettingModal}</div>;
}
